import { resolveMediaUrl } from '../api/baseUrl';

export const getVehicleImagePath = (vehicle) => {
    if (!vehicle || typeof vehicle !== 'object') return null;
    return (
        vehicle.image ??
        vehicle.Image ??
        vehicle.fleetImage ??
        vehicle.FleetImage ??
        vehicle.thumbnail ??
        vehicle.Thumbnail ??
        null
    );
};

export const getFranchiseImagePath = (vehicle) => {
    if (!vehicle || typeof vehicle !== 'object') return null;
    return vehicle.franchiseImage ?? vehicle.FranchiseImage ?? null;
};

export const getVehicleImageUrl = (vehicle, fallback = null) => {
    return resolveMediaUrl(getVehicleImagePath(vehicle)) || fallback;
};

export const getFranchiseImageUrl = (vehicle, fallback = null) => {
    return resolveMediaUrl(getFranchiseImagePath(vehicle)) || fallback;
};
